import { Icon } from "@mui/material";
import React from "react";

import "../../shared/css/basicStyles.css";
import "../../shared/css/ui.css";
import "../css/Collection.css";

import Collection from "../../shared/cover/Collection";
import { Collection as CollectionType } from "../../shared/types/Collection";
import CollectionTopbar from "./CollectionTopbar";

type Props = {
  data: CollectionType[] | undefined;
  isLoading: boolean;
  hasError: boolean;
  onRetry: () => void;
};

const AllCollectionVisual = (props: Props) => {
  const { data, isLoading, hasError, onRetry } = props;

  return (
    <div className="col-page">
      <CollectionTopbar title="Collections" />

      {isLoading ? (
        <div className="col-grid col-grid--collections" aria-busy="true" aria-label="Chargement des collections">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="nbk-skeleton col-skeleton__collection" />
          ))}
        </div>
      ) : hasError ? (
        <div className="col-state" role="alert">
          <Icon aria-hidden="true">cloud_off</Icon>
          <h1>Impossible de charger les collections</h1>
          <p>Vérifiez votre connexion internet puis réessayez.</p>
          <button type="button" className="nbk-btn nbk-btn--primary" onClick={onRetry}>
            <Icon aria-hidden="true">refresh</Icon>
            Réessayer
          </button>
        </div>
      ) : data && data.length > 0 ? (
        <>
          <h1 className="col-page__title">Toutes les collections</h1>
          <p className="col-page__subtitle">Des séries regroupées par thème et par éditeur.</p>
          <div className="col-grid col-grid--collections">
            {data.map((c: CollectionType) => (
              <Collection key={c.uid} collection={c} />
            ))}
          </div>
        </>
      ) : (
        <div className="col-state">
          <Icon aria-hidden="true">collections_bookmark</Icon>
          <h1>Aucune collection pour le moment</h1>
          <p>Revenez bientôt pour découvrir nos collections.</p>
        </div>
      )}
    </div>
  );
};

export default AllCollectionVisual;
